module.exports = __webpack_public_path__ + "images/01452f0e56ab5e55aa5c43ee332b2897-Tauck.jpg";